import { Layout } from 'antd';
import AuditOverview from './audit-system';
import HeaderBar from 'Layout/HeaderBar';
import FooterBar from 'Layout/FooterBar';

const { Content } = Layout;

function InternalAuditOverviewContainer() {
  return (
    <Layout>
      <HeaderBar />
      <Content
        style={{
          margin: '24px 24px 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <AuditOverview />
      </Content>
      <FooterBar />
    </Layout>
  );
}

export default InternalAuditOverviewContainer;
